import axios from 'axios';

export default {
    showFile(payload) {
        this.$refs.FilterControl.loading = true;
        this.$refs.ModalFile.fileStream = null;
        this.$store.dispatch('getFile', payload).then(response => {
            this.$refs.ModalFile.fileStream = response;
            this.$store.dispatch('getArquivoById', payload).then(file => {
                this.$refs.ModalFile.arquivo = file;
            });
            $('#ModalFile').modal('toggle');
        }).finally(final => {
            this.$refs.FilterControl.loading = false;
        });
    },
    downloadFile(payload) {
        this.$refs.FilterControl.loading = true;
        this.$store.dispatch('downloadFile', payload).then(response => {}).finally(final => {
            this.$refs.FilterControl.loading = false;
        });
    },
    downloadFileWithLog(payload) {
        this.$refs.FilterControl.loading = true;
        this.$store.dispatch('downloadFileWithLog', payload).then(response => {}).finally(final => {
            this.$refs.FilterControl.loading = false;
        });
    },
    fetchFiles(payload) {
        if (payload) {
            this.loadingId = this.createUUID();
            if (!this.query.page) {
                return
            }
            this.query.page = payload;
            //this.loadingId = this.createUUID();
        }
        this.$refs.FilterControl.fetch();

    },
    getFiles(payload) {
        this.loadingId = this.createUUID();
        this.params = payload
        this.$refs.FilterControl.loading = true;
        axios.get(this.url, {
                params: payload,
            })
            .then(res => {
                this.$refs.FilterControl.loading = false;
                if (res.data.collection) {
                    //Salvando os dados na loja.
                    this.$store.commit(this.storeAction, res.data.collection.data);
                    this.$refs.FilterControl.query.page = res.data.collection.current_page;
                }
            })
            .catch(error => {
                this.$refs.FilterControl.loading = false;
                console.error(error);
            })
            .finally(() => {
                this.$refs.FilterControl.loading = false;
                this.loading = false;
            });
    },
    teste(payload, data) {
        alert('Função não implementada.');
    },
    renameFile(data) {
        this.$refs.ModalRenameFile.file = _.cloneDeep(data);
        $('#ModalRenameFile').modal('toggle');
    },
    moveFile(data) {
        this.$refs.ModalMoveFile.file = data;
        $('#ModalMoveFile').modal('toggle');
    },
    copyLink(data) {
        this.copy(`${window.location.host}/validador?arquivo=${data.id}`);
    },
    selectFolder(folder) {
        this.selectedFolder.selected = false;
        this.selectedFolder = folder;
        this.selectedFolder.selected = true;
    },
    onOpenFolder(event, folder, top, left) {
        this.selectFolder(folder);
        this.$refs.menuFile.close();
    },
    onCloseFolder() {
        this.selectedFolder.selected = false;
    },
    onOpenFile(event, file, top, left) {
        this.$refs.menuFolder.close();
        this.selectedFolder.selected = false;
        this.selectedFile = file;
        this.selectedFile.selected = true;
    },
    onCloseFile() {
        this.selectedFile.selected = false;
    },
    prepareFolderOperation(payload) {
        if (payload === 'DELETE') {
            this.$refs.mFolder.folder = _.cloneDeep(this.selectedFolder);
            this.$refs.mFolder.destroyLevel();
            return
        }
        if (payload == 'STORE') {
            this.$refs.mFolder.folder = _.cloneDeep(this.folders);
            this.$refs.mFolder.folder.parentText = this.folders.title;
            this.$refs.mFolder.folder.title = null;
        } else {
            this.$refs.mFolder.folder = _.cloneDeep(this.selectedFolder);
            this.$refs.mFolder.folder.parentText = this.selectedFolder.title;
        }
        this.$refs.mFolder.folder.operation = payload;
        setTimeout(function () {
            $('#Nome').focus();
        }, 500);
        $('#ModalEditarNivel').modal('toggle');
    },
    openFolder(item) {
        this.loading = true;
        this.$store.dispatch('openFolder', item.id).then(response => {
            this.loading = false;
            this.selectedFiles = [];
            this.files.map(item => {
                item.selected = false;
            });
            document.querySelectorAll('input[type=checkbox]').forEach(el => el.checked = false);
        });
    },
    backFolder() {
        this.loading = true;
        this.$store.dispatch('backFolder', this.folders.id).then(response => {
            this.loading = false;
            this.selectedFiles = [];
            this.files.map(item => {
                item.selected = false;
            });
            document.querySelectorAll('input[type=checkbox]').forEach(el => el.checked = false);
        });
    },
    deleteFile(payload) {
        Swal.fire({
            title: trans('words.atention'),
            html: `Deletando o arquivo <b>${payload.arquivo_nome}</b><br>
  <small> OBS: Confirmando, seu arquivo será deletado <b>permanentemente.</b></small>`,
            icon: 'warning',
            input: 'text',
            inputPlaceholder: 'Digite CONFIRMA para continuar',
            showCancelButton: true,
            allowOutsideClick: true,
            cancelButtonText: trans('words.close'),
            confirmButtonText: 'Confirmar',
            confirmButtonClass: 'btn btn-danger btn-lg float-right',
            cancelButtonClass: 'btn btn-default btn-lg float-left',
            buttonsStyling: false,
            reverseButtons: true,
            showLoaderOnConfirm: true,
            inputValidator: (value) => {
                return new Promise((resolve) => {
                    if (value !== 'CONFIRMA') {
                        resolve('Por favor, digite a palavra `CONFIRMA` para continuar');
                    } else {
                        resolve();
                    }
                });
            },
            preConfirm: (confirm) => {
                return this.$store.dispatch('destroyFile', payload.id);
            }
        }).then(response => {
            if (response.dismiss) {
                return;
            }
            switch (response.value.status) {
                case 'success':
                    Swal.fire({
                        icon: 'success',
                        title: 'Exclusão de Arquivo',
                        html: response.value.message,
                        showCancelButton: true,
                        confirmButtonClass: 'btn btn-default btn-lg float-right',
                        cancelButtonClass: 'btn btn-default invisible btn-lg float-left',
                        buttonsStyling: false,
                        confirmButtonText: trans('words.close'),
                        reverseButtons: true
                    });
                    this.fetchFiles(1);
                    break;
                default:
                    Swal.fire({
                        icon: response.value.status,
                        title: 'Exclusão de Arquivo',
                        html: response.value.message,
                        showCancelButton: true,
                        allowOutsideClick: true,
                        cancelButtonText: trans('words.close'),
                        confirmButtonText: trans('words.close'),
                        confirmButtonClass: 'btn btn-default btn-lg float-right',
                        cancelButtonClass: 'btn btn-default btn-lg float-left invisible',
                        buttonsStyling: false,
                        reverseButtons: true
                    });
                    break;
            }
        });
    },
    cancelFile(payload) {
        Swal.fire({
            title: trans('words.atention'),
            html: `Cancelando o arquivo <b>${payload.arquivo_nome}</b><br>
  <small> OBS: Confirmando, seu arquivo será cancelado <b>permanentemente.</b>, impossibilitando assinaturas.</small>`,
            icon: 'warning',
            input: 'text',
            inputPlaceholder: 'Digite CONFIRMA para continuar',
            showCancelButton: true,
            allowOutsideClick: true,
            cancelButtonText: trans('words.close'),
            confirmButtonText: 'Confirmar',
            confirmButtonClass: 'btn btn-danger btn-lg float-right',
            cancelButtonClass: 'btn btn-default btn-lg float-left',
            buttonsStyling: false,
            reverseButtons: true,
            showLoaderOnConfirm: true,
            inputValidator: (value) => {
                return new Promise((resolve) => {
                    if (value !== 'CONFIRMA') {
                        resolve('Por favor, digite a palavra `CONFIRMA` para continuar');
                    } else {
                        resolve();
                    }
                });
            },
            preConfirm: (confirm) => {
                return this.$store.dispatch('cancelFile', payload.id);
            }
        }).then(response => {
            if (response.dismiss) {
                return;
            }
            switch (response.value.status) {
                case 'success':
                    Swal.fire({
                        icon: 'success',
                        title: 'Cancelamento de Arquivo',
                        html: response.value.message,
                        showCancelButton: true,
                        confirmButtonClass: 'btn btn-default btn-lg float-right',
                        cancelButtonClass: 'btn btn-default invisible btn-lg float-left',
                        buttonsStyling: false,
                        confirmButtonText: trans('words.close'),
                        reverseButtons: true
                    });
                    this.fetchFiles(1);
                    break;
                default:
                    Swal.fire({
                        icon: response.value.status,
                        title: 'Cancelamento de Arquivo',
                        html: response.value.message,
                        showCancelButton: true,
                        allowOutsideClick: true,
                        cancelButtonText: trans('words.close'),
                        confirmButtonText: trans('words.close'),
                        confirmButtonClass: 'btn btn-default btn-lg float-right',
                        cancelButtonClass: 'btn btn-default btn-lg float-left invisible',
                        buttonsStyling: false,
                        reverseButtons: true
                    });
                    break;
            }
        });
    },
    denyFile(payload) {
        this.$refs.ModalRecusa.file = payload;
        $('#ModalRecusa').modal();
    },
    deleteFile_(payload) {
        this.$refs.FilterControl.loading = true;
        this.$store
            .dispatch('destroyFile', payload.id)
            .then(response => {
                toastr({
                    title: response.message,
                    icon: response.status
                });
                this.$refs.FilterControl.loading = false;
                if (response.status == 'success') {
                    this.fetchFiles(1);
                }
            });
    },
    envioEmail(file) {
        this.$refs.ModalEnvioAssinatura.file = _.cloneDeep(file);
        this.$refs.ModalEnvioAssinatura.display = true;
        setTimeout(() => {
            this.$refs.ModalEnvioAssinatura.focusAutocomplete();
        }, 300);
        $('#ModalEnvioAssinatura').modal('toggle');
    },
    autoAssinar(file) {
        this.$refs.ModalAutoAssinar.file = _.cloneDeep(file);
        this.$refs.ModalAutoAssinar.display = true;
        this.$refs.FilterControl.loading = false;
        $('#ModalAutoAssinar').modal('toggle');

    },
    infiniteHandler($state) {
        if (this.query.page == 1) {
            this.query.page = Number(this.query.page) + 1;
            $state.loaded();
            return;
        }
        axios.get(this.url, {
            params: this.$refs.FilterControl.getParams()
        }).then(response => {
            this.$store.commit(this.infiniteAction, response.data.collection.data);
            if (response.data.collection.data.length == 5) {
                this.query.page = Number(this.query.page) + 1;
                $state.loaded();
            } else {
                $state.complete();
                //this.loadingId = this.createUUID();
            }
        });
    },
    signWithCertificate(file) {
        this.signatureCertificate = true;
        this.$refs.FilterControl.loading = true;
        setTimeout(() => {
            this.$refs.ModalCertificate.file = file;
            this.$refs.FilterControl.loading = false;
            $('#ModalCertificate').modal('toggle');
        }, 400);
    },
    signWithCertificatePublic(file) {
        this.signatureCertificate = true;    
        setTimeout(() => {
            this.$refs.ModalCertificate.file = file;
            this.$refs.ModalCertificate.request.assinatura_documento = this.request.assinatura_documento;
            $('#ModalCertificate').modal('toggle');
        }, 400);
    },
    signWithoutCertificate(file) {
        this.$refs.ModalAssinar.file = file;
        $('#ModalAssinar').modal();
    },
    showSign(data) {
        if (!data) {
            return false;
        }
        if (data.finished) {
            return false;
        }
        if (!data.assinaturas.length) {
            return false;
        }
        return data.assinaturas.findIndex(x => x.fk_user_id == this.auth_user.id && !x.assinado_em) > -1;
    },
    showShare(data) {
        if (!data) {
            return false;
        }

        if (!data.fk_user_id) {
            return true;
        }

        return this.auth_user.id === data.fk_user_id;

    },
    showDelete(data) {
        if (process.env.NODE_ENV != 'production') {
            return true;
        }
        
        if (!data) {
            return false;
        }

        if (!data.fk_user_id) {
            return true;
        }

        if (data.finished) {
            return false;
        }

        if (data.assinaturas.findIndex(x => x.assinado) > -1) {
            return false;
        }

        return this.auth_user.id === data.fk_user_id;
    },
    openFileMenu(event, payload) {
        this.$refs.menuFile.open(event, payload);
    },
    openFolderMenu(event, payload) {
        this.$refs.menuFolder.open(event, payload);
    },
    showSignatures(file) {
        this.$refs.ModalShowSignatures.file = file;
        $('#ModalShowSignatures').modal('toggle');
    },
    baixarLote() {
        this.$refs.FilterControl.loading = true;
        let req = {
            ids: this.selectedFiles.map(item => {
                return item.id
            })
        };
        this.$store.dispatch('downloadFileLote', req).then(response => {
            console.log(response);
        }).catch(error => {

        }).finally(() => {
            this.$refs.FilterControl.loading = false;
        });
    },
    baixarLogLote() {
        this.$refs.FilterControl.loading = true;
        let req = {
            ids: this.selectedFiles.map(item => {
                return item.id
            })
        };
        this.$store.dispatch('downloadFileWithLogLote', req).then(response => {
            console.log(response);
        }).catch(error => {

        }).finally(() => {
            this.$refs.FilterControl.loading = false;
        });
    },
    envioEmailLote() {

    },
    deleteFileLote() {

    },
    moverLote() {
        this.$refs.ModalMoveFile.file = {
            id: this.selectedFiles.map(item => {
                return item.id
            }),
            arquivo_nome: this.selectedFiles.map(item => {
                return item.arquivo_nome
            }),
            fk_nivel_id: this.selectedFiles[0].fk_nivel_id
        };
        $('#ModalMoveFile').modal('toggle');
    }
}